// extracted by mini-css-extract-plugin
export default {"progressContainer":"BriLinearProgress_progressContainer__bK-5j"};